module.exports = __webpack_public_path__ + "images/statistics@2x.png?89f9bc75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/statistics@2x.png
// module id = 708
// module chunks = 7